/* eslint-disable no-restricted-globals */
import { useMemo } from 'react';

import Explanation from '../../components/AddOrEditPage/AddOrEditLoan/Sections/LenderHistory/Explanation';

import LenderService from '../../services/LenderService';
import useForm from '../utils/useForm';

const useLenderHistoryForm = (onSubmit, values) => {
  /*  const submitHandler = (formValues, actions) => {
    onSubmit(formValues);
    actions.resetForm();
  };
 */
  const fields = useMemo(
    () => [
      {
        title: 'Lender History',
        type: 'array',
        name: 'lender_history',
        isTitleHidden: true,
        isDeleteDisabled: (vals, index) => index === 0,
        noteComponent: Explanation,
        noteComponentProps: (index, formikValues) => {
          return {
            index,
            lenderHistory: formikValues?.lender_history,
            lenderHistoryElement: formikValues?.lender_history?.[index],
            loanId: formikValues?.id,
          };
        },
        fields: [
          {
            title: 'Lender',
            name: 'lender_id',
            type: 'fetchableSelect',
            fetchOptions: {
              key: ['lenders'],
              queryFn: LenderService.getLenders,
              labelKey: 'name',
            },
            required: true,
          },
          {
            title: 'Effective Date',
            name: 'effective_date',
            type: 'date',
            required: true,
            tooltip: 'Date the loan was sold',
          },
          {
            title: 'Interest Effective Date',
            name: 'interest_effective_date',
            type: 'date',
            required: true,
            tooltip: 'Date the new lender should begin receiving interest',
          },
        ],
      },
    ],
    [values?.id, values?.lender_history]
  );

  const form = useForm({
    fields,
    onSubmit,
    values,
  });

  return form;
};

export default useLenderHistoryForm;
